import { render } from "./lakehouse.vue?vue&type=template&id=1636d1c8&scoped=true"
import script from "./lakehouse.vue?vue&type=script&lang=js"
export * from "./lakehouse.vue?vue&type=script&lang=js"

import "./lakehouse.vue?vue&type=style&index=0&id=1636d1c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1636d1c8"]])

export default __exports__